module.exports = __webpack_public_path__ + "static/logo-d507a23997bea52165f1f68961c283c8.svg";